module.exports = __webpack_public_path__ + "img/stock3.89e8c4b0.png";